/*jslint evil: true, forin: true */
/************************************************************************
' Script		: IsiControlesNames.js
' Auteur        : ABUR
' Date creation : 16/04/2004
' Modificateur  : ABUR
' Date modif.   : 16/04/2004
' Description   : Liste des identifiants possibles pour les controles 
'				  presents dans des controles composites
' Commentaires	: 
'***********************************************************************/

// ############################### ATTENTION ###############################
// Ce fichier est egalement present en VB, toute modification dans l'un
// doit etre repercutee dans l'autre !
// Noubliez pas non plus IsiCtrlData.GetControlTypeToName()
// #########################################################################
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Label"

const LABEL = "l"; // Anciennement le _Lbl_ / Anciennement Lbl
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiTextNum
const LABEL_CURRENCY = "lcu"; //Anciennement LblCurr
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiNavigationToolBar
const LABEL_SPACE = "ls"; //Ancienenement LblSp
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiGrid
const LABEL_TITLE = "lt"; //Ancienenement LblTitle
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiGrid
const LABEL_NBRECORD = "lnr"; //Ancienenement LblNbRd
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiGrid
const LABEL_TXT_NBRECORD = "ltnr"; //Ancienenement LblTxtNbRd
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.TextBox"
const TEXTBOX = "t"; // Anciennement le _WI_ pour les IsiTextBox, IsiMemo, IsiQuickSearch, IsiTextConnexe / Anciennement TxtBox
//' Correspond a un controle de type "System.Web.UI.WebControls.TextBox" sur la IsiTextBox
const TEXTBOX_FAST_ID = "tfi"; //Ancienenement TxtBoxFastId
//' Correspond a un controle de type "System.Web.UI.WebControls.TextBox" sur la IsiTextConnexe
const TEXTBOX_MULTI = "tm"; // Anciennement le _WI_ pour les IsiTextBoxMutltiligne //Ancienenement TxtBoxMulti
//' Correspond a un controle de type "System.Web.UI.WebControls.TextBox" sur la IsiComboCritere
const TEXTBOX_ENTER = "te"; //Ancienenement TxtBoxEnt
//' Correspond a tous les controles "uniques" de type "System.Web.UI.HtmlControls.HtmlInputFile"
const TEXTBOXFILE = "tf"; //Ancienenement TxtBoxFile
//' Correspond a tous les controles "uniques" correspondant a la div
const TEXTDIV = "td"; //Ancienenement TxtDiv
//' Correspond a tous les controles "uniques" de type "System.Web.UI.HtmlControls.HtmlInputHidden"
const HIDDEN = "h"; //Ancienenement Hidd
//' Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiCtrlData
const HIDDEN_VALUE = "hv"; //Ancienenement HiddVal
//' Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiCtrlConnexe
const HIDDEN_OTHERVALUE = "hov"; //Ancienenement HiddOtherVal
// Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiCtrlConnexe
const HIDDEN_MODIF = "hm"; //Ancienenement HiddModif

//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Button"
const BUTTON = "b";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Link"
const LINK = "lk";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.LinkButton"
const LINK_BUTTON = "lkb";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.HyperLink"
const HYPER_LINK = "hyl";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Image"
const IMAGE = "i";
//' Correspond a un controle de type "System.Web.UI.WebControls.Image" sur IsiGrid
const IMAGE_LEFT = "ImgLeft";
//' Correspond a un controle de type "System.Web.UI.WebControls.Image" sur IsiGrid
const IMAGE_RIGHT = "ImgRight";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.ImageButton"
const IMAGE_BUTTON = "ib";
// Image du suggest.
const IMAGE_SUGGEST = "sug";
// image propriete des contr�les connexes.
const IMAGE_BUTTON_PROPERTY = "ibp";

//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
const IMAGE_BUTTON_XML = "ImgBtnXml";
//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
const IMAGE_BUTTON_EXCEL = "ImgBtnXls";
//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
const IMAGE_BUTTON_REFRESH = "ImgBtnRfr";
//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
const IMAGE_BUTTON_HIER = "ImgBtnHier";


//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
const IMAGE_BUTTON_DELETE = "ImgBtnDelete";
// Correspond a la partie donnees du controle pieces jointes
const ATTPREV_DATA = "pjetapercu_div";
// Correspond au bouton propri�t�s du controle pieces jointes
const ATTPREV_PROPERTIES = "properties_img";
// Correspond � l'affichage de la pi�ce jointe
const ATTPREV_JOINEDFILE = "DOCOLE_img";
// Correspond au bouton trombone du controle pieces jointes
const ATTPREV_LINK = "go_img";
// Correspond au cadre contenant la liste des pieces jointes
const ATTPREV_CADREPJ = "cadrePJ_div";
// Correspond � l'id de la sous-division pour les pi�ces jointes en vintage
const ATTVINTAGE_PJ_DIV = "pj_div";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Panel"
const PANEL = "p"; // Anciennement le _WI_ pour les IsiPanel
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.CheckBox"
const CHECKBOX = "cb";
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.DropDownList"
const COMBOBOX = "cmb"; // Anciennement le _WI_ pour les IsiCombo
const COMBOBOXVALUE = "cmbv";
// div contenant la zone HTML du contr�le Html
const ZONEHTML = "z";
// div contenant la zone HTML du contr�le Html
const DATALIST = "iLst";

// ORIC - 2006.09.08 - [TACHE:8171] : Ces constantes correspondent aux separateurs utilises pour les ID des 
// controles encapsules dans la IsiGrid.
const SEP_ENCAPS_GRID = "x";
const SEP_ENCAPS_CTRL = "_";
const PREFIX_TABLE_DATE = 'igtxt';
// div du panel
const PANEL_DIV = "dv";
//correspond a l'aspect de la combo, celui-ci est precede de COMBOBOX
const CBMAIN = "_Main";
const CBINPUT = "_input";




/// <summary>Div g�rant l'alignement � droite sur les textconnexes</summary>
const SHOWN_VALUE = "sv";

// Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiWebTab.
const HIDDEN_VALUE_WEBTAB_CURRENT_TAB = "hdct";

// Correspond au bouton sur lequel on vient de clicker dans la NavigationToolBar. Ce controle est renseigne en javascript
const NAV_ITEM_CLICK_ID = "nic";

//  Correspond a tous les controles "uniques" de type "Infragistics.WebUI.UltraWebNavigator.UltraWebTree"
const TREEVIEW = "tv";
//  Correspond a tous les controles "uniques" de type Hidden dans le treeView
const HIDDEN_CHECKED_TREEVIEW = "hct";
//  Correspond a tous les controles "uniques" de type Hidden dans le treeView
const HIDDEN_SEE_CHECKED_TREEVIEW = "hsct";
// Correspond au node sur lequel on vient de clicker. Ce controle est renseigne en javascript
const HIDDEN_NODE_CLICKED = "hns";
// Indique qu'on effectue une validation sur le clique d'un treeview. Ce controle est utilise en javascript
const HIDDEN_VALIDATE_ON_NODE_CLICKED = "hvonc";
// Identifiant des formulaires
const FORM_ID = "Form1";
// Correspond a la div left
const DIV_LEFT = "DivLeft";
// Correspond a la div de gauche
const DIV_MENU = "DivMenu";
// Correspond au div contenant le bandeau principal de l'application
const DIV_BANNER = "DivBanner";
// Correspond au div contenant l'entete des pages
const DIV_ENTETE = "DivEntete";
// Correspond au div de la partie maitre
const DIV_MAINCONTENT = "DivMainContent";
// Correspond au div contenant les controles formulaire
const DIV_FORMULAIRE = "DivFormulaire";
// Correspond au div contenant les details
const DIV_DETAIL = "DivDetail";
// Correspond au div contenant la grille des details
const DIV_DETAIL_GRID = "DivDetailGrid";
// Correspond au div contenant le grip des details
const DIV_DETAIL_GRIP = "DivDetailGrip";


// Correspond au div contenant le message d'attente entre les pages
const DIV_ATTENTE = "DivAttente";
// JSOU - 22/03/2011 - Dev 41549 Message d'attente identique a Normea
const DIV_MSGATTENTE = "DivMsgAttente";
// ABUR - 2008.07.30 - [DYSFCT:0000023751]

//ABON div du logo
const DIV_LOGO = "DivLogo";
//ABON div module
const DIV_MODULE = "DivModule";
//ABON div rac bandeau
const DIV_RACBANDEAU = "DivRacBandeau";
//ABON div du mode de l'application (marquage)
const DIV_PARAM = "DivParam";
//ABON div bouton Iws
const DIV_BANICO = "DivBanIco";
//ABON div de la boite des perfs
const DIV_PERFBOX = "DivPerfBox";
//ABON div du menu principal
const DIV_MENUPRINC = "DivMenuPrinc";

// LFEN div de la banni�re globale
const IdDivBannerGlobal = "DivBannerGlobal";

// Correspond au div contenant l'image de la societe ("company_image.png")
const DIV_BOX_IMG_SOC = "BoxImgSoc";


const MNU_MASTER = "mm";
// Nom du menu detail
const MNU_DETAIL = "md";

// Todo RWD
// A voir s'il faut fusionner avec la constante menu master
const PRE_MNU_MASTER = "FormHeader";
const PRE_MNU_DETAIL = "DetailHeader";

// ARAN 14/01/2009 DEV 20502
const MNU_PAGE = "mp";

// menu extendednews
const MNU_EXT_NEWS = "extnews";

// GBAU - POPIN
const MNU_MODULE = "MODULE";

// Image du suggest.
const DIAGRAM_SHAPE = "ds";
const WORKFLOWV2 = "wfv2";
const MNU_SEP = "##";
const FORM_MNUGRP_NAVIGATION = "FORM_NAVIGATION_GROUP";
const DATA_MNUGRP_NAVIGATION = "DATA_NAVIGATION_GROUP";
const MNUGRP_ASSOCIATEDVIEW = "FORM_ASSOCIATEDVIEW_GROUP";
const FORM_MNUGRP_TREATMENT = "FORM_TREATMENT_GROUP";
const DATA_MNUGRP_TREATMENT = "DATA_TREATMENT_GROUP";
const FORM_MNUGRP_MISC = "FORM_MISCELLANEOUS_GROUP";
const DATA_MNUGRP_MISC = "DATA_MISCELLANEOUS_GROUP";
const FORM_MNUGRP_OTHER = "FORM_OTHERS_GROUP";
const DATA_MNUGRP_OTHER = "DATA_OTHERS_GROUP";
const FORM_MNUGRP_OTHERNAV = "FORM_OTHERSNAV_GROUP";
const DATA_MNUGRP_OTHERNAV = "DATA_OTHERSNAV_GROUP";

// nom de l'element affichant les message d'attente
const TAB_MESSAGE = "tdMessage";
// nom de l'element permettant d'afficher l'element de message
const TAB_ATTENTE = "tdAttente";
const NAV_ID = "ntb";  //Anciennement isiNavigationToolBar

// PBON 04/02/05 : Variables de gestion des formats monetaires
const SEP_DECIMAL_JAVASCRIPT = ".";
const SEP_DECIMAL_WEB = ",";
const SEP_MILLIER = " ";

const SEP_CTRLPROP = "#!";
const SEP_CTRL = "!!#";

// Constantes associees au controle IsiTextDate
// Id du conteneur de la date
const VIEW_DATE_TIME_CTR = "vdtctr";
// Id du controle de visualisation de la date (Text box date)
const VIEW_DATE_TIME = "vdt";
// Id du controle de visualisation de la date (Text box) pour la recherche
const VIEW_DATE_TIME_SEARCH = "vdts";
// Id du controle de visualisation de la date (Text box) pour la recherche
const VIEW_DATE_TIME_HIDDEN = "vdth";
// Id du controle de visualisation de la date (Text box) pour stocker le format de la date
const VIEW_DATE_TIME_FORMAT = "vdtf";
// Id du controle de saisie de la date (calandar)
const CHOOSE_DATE = "cd";
// Id du controle calendrier (calandar) interne au controle IsiComboCalendar
const COMBO_CALENDAR = "c";
// Id du controle calendrier (calandar) IsiComboCalendar utilise pour les controles IsiTextDate
const CALENDAR = "CalendarPicker";
// Id de la DIV utilisee sous les TextConnexes pour afficher la liste de suggestion.
const DIV_SUGGEST = "sug";
// Id du controle IsiCalendarView.
const ISICALENDARVIEW = "cv";
// Id du controle IsiCalendarView.
const ISISCHEDULECTRL = "sc";
// Id du controle IsiCalendarView.
const ISISCHEDULEPROPERTIESCTRL = "scpc";
// Id du controle IsiCalendarView.
const ISIATTPREVIEW = "ap";
// Id du controle IsiColorPicker.
const ISICOLORPICKER = "cp";
//' Id du controle IsiIconChooser.
const ISIICONCHOOSER = "ch";

const ISIMEMORICHTXT = "richtext";
const ISIGENERIC = "ge";

// MaskEdit Extender
const MASK_EDIT_EXTENDER = "meext";
// MaskEdit Validator
const MASK_EDIT_VALIDATOR = "meval";
// MaskEdit Callout
const MASK_EDIT_CALLOUT = "callout";

// ORIC - 060511 - Constantes qui representes les 5 etats possibles du curseur.
// Correspond a l'enumeration IsiStateType de la classe IsiCursor.
const CURSOR_STATE_SEARCH = "0";
const CURSOR_STATE_ADD = "1";
const CURSOR_STATE_UPDATE = "2";
const CURSOR_STATE_CONSULT = "3";
const CURSOR_STATE_DUPLICATE = "4";
//GBAU : 13/01/2012 : Rajout de la 5eme valeur manquante
const CURSOR_STATE_NONE = "5";
//JSOU : 07/04/2014 : Etat Reserve pour edition
const CURSOR_STATE_LOCK = "6";

// Id du controle Isiworkflow
const ISIWORKFLOW = "wf";
// Id du controle Isioverview
const ISIOVERVIEW = "IsiOverView";
// Id du controle IsiWorkflowImpact
const ISIWORKFLOWIMPACT = "wfi";
// Id du controle IsiExtSearch
const ISIEXTSEARCH = "es";

// Id du controle IsiTimeProgress.
const ISITIMEPROGRESS = "tp";
// id du Diagram shape
const ISIDIAGRAMSHAPE = "ds";
// id du ComboBoxYesNoSwitch
const ISICOMBOYESNOSWITCH = "swtbtn";
// id du composant scan
const ISIASSISTANTSCAN = "as";
// id du controle dynamique
const ISIDYNAMIC = "dy";
// Id du controle IsiTimeProgress.
const ISIWEBTAB = "wt";

// Id du controle IsiTimeProgress.
const ISIWEBTABITEM = "wti";

//Criteres
// valeur des operateurs
const CRIT_ENTRE = '[ ]';
const CRIT_HENTRE = '] [';
const CRIT_DANS = '( )';
const CRIT_HDANS = ') (';
const CRIT_EMPTY = ' ';
const CRIT_EQUALS = '=';
const CRIT_DIFF = '<>';
const CRIT_SUP = '>';
const CRIT_SUPEQ = '>=';
const CRIT_INF = "<";
const CRIT_INFEQ = '<=';

// Id du sous controle connexe du controle dynamique
const DYN_CTRLCNX = "dynCtrlCnx";

const CstFORM = "FORM_";
const CstDATA = "DATA_";

const SQLTEXTEDITOR = "ste";

/*******************************/
//Replace const ([a-zA-Z0-9_]*) = .*; avec window.$1 = $1;
window.LABEL = LABEL; // Anciennement le _Lbl_ / Anciennement Lbl
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiTextNum
window.LABEL_CURRENCY = LABEL_CURRENCY; //Anciennement LblCurr
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiNavigationToolBar
window.LABEL_SPACE = LABEL_SPACE; //Ancienenement LblSp
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiGrid
window.LABEL_TITLE = LABEL_TITLE; //Ancienenement LblTitle
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiGrid
window.LABEL_NBRECORD = LABEL_NBRECORD; //Ancienenement LblNbRd
//' Correspond a un controle de type "System.Web.UI.WebControls.Label" sur IsiGrid
window.LABEL_TXT_NBRECORD = LABEL_TXT_NBRECORD; //Ancienenement LblTxtNbRd
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.TextBox"
window.TEXTBOX = TEXTBOX; // Anciennement le _WI_ pour les IsiTextBox, IsiMemo, IsiQuickSearch, IsiTextConnexe / Anciennement TxtBox
//' Correspond a un controle de type "System.Web.UI.WebControls.TextBox" sur la IsiTextBox
window.TEXTBOX_FAST_ID = TEXTBOX_FAST_ID; //Ancienenement TxtBoxFastId
//' Correspond a un controle de type "System.Web.UI.WebControls.TextBox" sur la IsiTextConnexe
window.TEXTBOX_MULTI = TEXTBOX_MULTI; // Anciennement le _WI_ pour les IsiTextBoxMutltiligne //Ancienenement TxtBoxMulti
//' Correspond a un controle de type "System.Web.UI.WebControls.TextBox" sur la IsiComboCritere
window.TEXTBOX_ENTER = TEXTBOX_ENTER; //Ancienenement TxtBoxEnt
//' Correspond a tous les controles "uniques" de type "System.Web.UI.HtmlControls.HtmlInputFile"
window.TEXTBOXFILE = TEXTBOXFILE; //Ancienenement TxtBoxFile
//' Correspond a tous les controles "uniques" correspondant a la div
window.TEXTDIV = TEXTDIV; //Ancienenement TxtDiv
//' Correspond a tous les controles "uniques" de type "System.Web.UI.HtmlControls.HtmlInputHidden"
window.HIDDEN = HIDDEN; //Ancienenement Hidd
//' Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiCtrlData
window.HIDDEN_VALUE = HIDDEN_VALUE; //Ancienenement HiddVal
//' Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiCtrlConnexe
window.HIDDEN_OTHERVALUE = HIDDEN_OTHERVALUE; //Ancienenement HiddOtherVal
// Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiCtrlConnexe
window.HIDDEN_MODIF = HIDDEN_MODIF; //Ancienenement HiddModif

//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Button"
window.BUTTON = BUTTON;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Link"
window.LINK = LINK;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.LinkButton"
window.LINK_BUTTON = LINK_BUTTON;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.HyperLink"
window.HYPER_LINK = HYPER_LINK;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Image"
window.IMAGE = IMAGE;
//' Correspond a un controle de type "System.Web.UI.WebControls.Image" sur IsiGrid
window.IMAGE_LEFT = IMAGE_LEFT;
//' Correspond a un controle de type "System.Web.UI.WebControls.Image" sur IsiGrid
window.IMAGE_RIGHT = IMAGE_RIGHT;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.ImageButton"
window.IMAGE_BUTTON = IMAGE_BUTTON;
// Image du suggest.
window.IMAGE_SUGGEST = IMAGE_SUGGEST;
// image propriete des contr�les connexes.
window.IMAGE_BUTTON_PROPERTY = IMAGE_BUTTON_PROPERTY;

//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
window.IMAGE_BUTTON_XML = IMAGE_BUTTON_XML;
//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
window.IMAGE_BUTTON_EXCEL = IMAGE_BUTTON_EXCEL;
//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
window.IMAGE_BUTTON_REFRESH = IMAGE_BUTTON_REFRESH;
//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
window.IMAGE_BUTTON_HIER = IMAGE_BUTTON_HIER;

//' Correspond a un controle de type "System.Web.UI.WebControls.ImageButton" sur IsiGrid
window.IMAGE_BUTTON_DELETE = IMAGE_BUTTON_DELETE;
// Correspond a la partie donnees du controle pieces jointes
window.ATTPREV_DATA = ATTPREV_DATA;
// Correspond au bouton propri�t�s du controle pieces jointes
window.ATTPREV_PROPERTIES = ATTPREV_PROPERTIES;
// Correspond � l'affichage de la pi�ce jointe
window.ATTPREV_JOINEDFILE = ATTPREV_JOINEDFILE;
// Correspond au bouton trombone du controle pieces jointes
window.ATTPREV_LINK = ATTPREV_LINK;
// Correspond au cadre contenant la liste des pieces jointes
window.ATTPREV_CADREPJ = ATTPREV_CADREPJ;
// Correspond � l'id de la sous-division pour les pi�ces jointes en vintage
window.ATTVINTAGE_PJ_DIV = ATTVINTAGE_PJ_DIV;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.Panel"
window.PANEL = PANEL; // Anciennement le _WI_ pour les IsiPanel
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.CheckBox"
window.CHECKBOX = CHECKBOX;
//' Correspond a tous les controles "uniques" de type "System.Web.UI.WebControls.DropDownList"
window.COMBOBOX = COMBOBOX; // Anciennement le _WI_ pour les IsiCombo
window.COMBOBOXVALUE = COMBOBOXVALUE;
// div contenant la zone HTML du contr�le Html
window.ZONEHTML = ZONEHTML;
// div contenant la zone HTML du contr�le Html
window.DATALIST = DATALIST;
// ORIC - 2006.09.08 - [TACHE:8171] : Ces constantes correspondent aux separateurs utilises pour les ID des 
// controles encapsules dans la IsiGrid.
window.SEP_ENCAPS_GRID = SEP_ENCAPS_GRID;
window.SEP_ENCAPS_CTRL = SEP_ENCAPS_CTRL;
window.PREFIX_TABLE_DATE = PREFIX_TABLE_DATE;
// div du panel
window.PANEL_DIV = PANEL_DIV;
//correspond a l'aspect de la combo, celui-ci est precede de COMBOBOX
window.CBMAIN = CBMAIN;
window.CBINPUT = CBINPUT;

/// <summary>Div g�rant l'alignement � droite sur les textconnexes</summary>
window.SHOWN_VALUE = SHOWN_VALUE;
// Correspond a un controle de type "System.Web.UI.HtmlControls.HtmlInputHidden" sur IsiWebTab.
window.HIDDEN_VALUE_WEBTAB_CURRENT_TAB = HIDDEN_VALUE_WEBTAB_CURRENT_TAB;

// Correspond au bouton sur lequel on vient de clicker dans la NavigationToolBar. Ce controle est renseigne en javascript
window.NAV_ITEM_CLICK_ID = NAV_ITEM_CLICK_ID;

//  Correspond a tous les controles "uniques" de type "Infragistics.WebUI.UltraWebNavigator.UltraWebTree"
window.TREEVIEW = TREEVIEW;
//  Correspond a tous les controles "uniques" de type Hidden dans le treeView
window.HIDDEN_CHECKED_TREEVIEW = HIDDEN_CHECKED_TREEVIEW;
//  Correspond a tous les controles "uniques" de type Hidden dans le treeView
window.HIDDEN_SEE_CHECKED_TREEVIEW = HIDDEN_SEE_CHECKED_TREEVIEW;
// Correspond au node sur lequel on vient de clicker. Ce controle est renseigne en javascript
window.HIDDEN_NODE_CLICKED = HIDDEN_NODE_CLICKED;
// Indique qu'on effectue une validation sur le clique d'un treeview. Ce controle est utilise en javascript
window.HIDDEN_VALIDATE_ON_NODE_CLICKED = HIDDEN_VALIDATE_ON_NODE_CLICKED;
// Identifiant des formulaires
window.FORM_ID = FORM_ID;
// Correspond a la div left
window.DIV_LEFT = DIV_LEFT;
// Correspond a la div de gauche
window.DIV_MENU = DIV_MENU;
// Correspond au div contenant le bandeau principal de l'application
window.DIV_BANNER = DIV_BANNER;
// Correspond au div contenant l'entete des pages
window.DIV_ENTETE = DIV_ENTETE;
// Correspond au div de la partie maitre
window.DIV_MAINCONTENT = DIV_MAINCONTENT;
// Correspond au div contenant les controles formulaire
window.DIV_FORMULAIRE = DIV_FORMULAIRE;
// Correspond au div contenant les details
window.DIV_DETAIL = DIV_DETAIL;
// Correspond au div contenant la grille des details
window.DIV_DETAIL_GRID = DIV_DETAIL_GRID;
// Correspond au div contenant le grip des details
window.DIV_DETAIL_GRIP = DIV_DETAIL_GRIP;

// Correspond au div contenant le message d'attente entre les pages
window.DIV_ATTENTE = DIV_ATTENTE;
// JSOU - 22/03/2011 - Dev 41549 Message d'attente identique a Normea
window.DIV_MSGATTENTE = DIV_MSGATTENTE;
// ABUR - 2008.07.30 - [DYSFCT:0000023751]

//ABON div du logo
window.DIV_LOGO = DIV_LOGO;
//ABON div module
window.DIV_MODULE = DIV_MODULE;
//ABON div rac bandeau
window.DIV_RACBANDEAU = DIV_RACBANDEAU;
//ABON div du mode de l'application (marquage)
window.DIV_PARAM = DIV_PARAM;
//ABON div bouton Iws
window.DIV_BANICO = DIV_BANICO;
//ABON div de la boite des perfs
window.DIV_PERFBOX = DIV_PERFBOX;
//ABON div du menu principal
window.DIV_MENUPRINC = DIV_MENUPRINC;

// LFEN div de la banni�re globale
window.IdDivBannerGlobal = IdDivBannerGlobal;

// Correspond au div contenant l'image de la societe ("company_image.png")
window.DIV_BOX_IMG_SOC = DIV_BOX_IMG_SOC;




window.MNU_MASTER = MNU_MASTER;
// Nom du menu detail
window.MNU_DETAIL = MNU_DETAIL;

// Todo RWD
// A voir s'il faut fusionner avec la constante menu master
window.PRE_MNU_MASTER = PRE_MNU_MASTER;
window.PRE_MNU_DETAIL = PRE_MNU_DETAIL;

// ARAN 14/01/2009 DEV 20502
window.MNU_PAGE = MNU_PAGE;

window.MNU_EXT_NEWS = MNU_EXT_NEWS;

// GBAU - POPIN
window.MNU_MODULE = MNU_MODULE;

// Image du suggest.
window.DIAGRAM_SHAPE = DIAGRAM_SHAPE;
window.WORKFLOWV2 = WORKFLOWV2;
window.MNU_SEP = MNU_SEP;
window.FORM_MNUGRP_NAVIGATION = FORM_MNUGRP_NAVIGATION;
window.DATA_MNUGRP_NAVIGATION = DATA_MNUGRP_NAVIGATION;
window.MNUGRP_ASSOCIATEDVIEW = MNUGRP_ASSOCIATEDVIEW;
window.FORM_MNUGRP_TREATMENT = FORM_MNUGRP_TREATMENT;
window.DATA_MNUGRP_TREATMENT = DATA_MNUGRP_TREATMENT;
window.FORM_MNUGRP_MISC = FORM_MNUGRP_MISC;
window.DATA_MNUGRP_MISC = DATA_MNUGRP_MISC;
window.FORM_MNUGRP_OTHER = FORM_MNUGRP_OTHER;
window.DATA_MNUGRP_OTHER = DATA_MNUGRP_OTHER;
window.FORM_MNUGRP_OTHERNAV = FORM_MNUGRP_OTHERNAV;
window.DATA_MNUGRP_OTHERNAV = DATA_MNUGRP_OTHERNAV;

// nom de l'element affichant les message d'attente
window.TAB_MESSAGE = TAB_MESSAGE;
// nom de l'element permettant d'afficher l'element de message
window.TAB_ATTENTE = TAB_ATTENTE;
window.NAV_ID = NAV_ID;  //Anciennement isiNavigationToolBar

// PBON 04/02/05 : Variables de gestion des formats monetaires
window.SEP_DECIMAL_JAVASCRIPT = SEP_DECIMAL_JAVASCRIPT;
window.SEP_DECIMAL_WEB = SEP_DECIMAL_WEB;
window.SEP_MILLIER = SEP_MILLIER;

window.SEP_CTRLPROP = SEP_CTRLPROP;
window.SEP_CTRL = SEP_CTRL;

// Constantes associees au controle IsiTextDate
// Id du conteneur de la date
window.VIEW_DATE_TIME_CTR = VIEW_DATE_TIME_CTR;
// Id du controle de visualisation de la date (Text box date)
window.VIEW_DATE_TIME = VIEW_DATE_TIME;
// Id du controle de visualisation de la date (Text box) pour la recherche
window.VIEW_DATE_TIME_SEARCH = VIEW_DATE_TIME_SEARCH;
// Id du controle de visualisation de la date (Text box) pour la recherche
window.VIEW_DATE_TIME_HIDDEN = VIEW_DATE_TIME_HIDDEN;
// Id du controle de visualisation de la date (Text box) pour stocker le format de la date
window.VIEW_DATE_TIME_FORMAT = VIEW_DATE_TIME_FORMAT;
// Id du controle de saisie de la date (calandar)
window.CHOOSE_DATE = CHOOSE_DATE;
// Id du controle calendrier (calandar) interne au controle IsiComboCalendar
window.COMBO_CALENDAR = COMBO_CALENDAR;
// Id du controle calendrier (calandar) IsiComboCalendar utilise pour les controles IsiTextDate
window.CALENDAR = CALENDAR;
// Id de la DIV utilisee sous les TextConnexes pour afficher la liste de suggestion.
window.DIV_SUGGEST = DIV_SUGGEST;
// Id du controle IsiCalendarView.
window.ISICALENDARVIEW = ISICALENDARVIEW;
// Id du controle IsiCalendarView.
window.ISISCHEDULECTRL = ISISCHEDULECTRL;
// Id du controle IsiCalendarView.
window.ISISCHEDULEPROPERTIESCTRL = ISISCHEDULEPROPERTIESCTRL;
// Id du controle IsiCalendarView.
window.ISIATTPREVIEW = ISIATTPREVIEW;
// Id du controle IsiColorPicker.
window.ISICOLORPICKER = ISICOLORPICKER;
//' Id du controle IsiIconChooser.
window.ISIICONCHOOSER = ISIICONCHOOSER;

window.ISIMEMORICHTXT = ISIMEMORICHTXT;
window.ISIGENERIC = ISIGENERIC;

// MaskEdit Extender
window.MASK_EDIT_EXTENDER = MASK_EDIT_EXTENDER;
// MaskEdit Validator
window.MASK_EDIT_VALIDATOR = MASK_EDIT_VALIDATOR;
// MaskEdit Callout
window.MASK_EDIT_CALLOUT = MASK_EDIT_CALLOUT;

// ORIC - 060511 - Constantes qui representes les 5 etats possibles du curseur.
// Correspond a l'enumeration IsiStateType de la classe IsiCursor.
window.CURSOR_STATE_SEARCH = CURSOR_STATE_SEARCH;
window.CURSOR_STATE_ADD = CURSOR_STATE_ADD;
window.CURSOR_STATE_UPDATE = CURSOR_STATE_UPDATE;
window.CURSOR_STATE_CONSULT = CURSOR_STATE_CONSULT;
window.CURSOR_STATE_DUPLICATE = CURSOR_STATE_DUPLICATE;
//GBAU : 13/01/2012 : Rajout de la 5eme valeur manquante
window.CURSOR_STATE_NONE = CURSOR_STATE_NONE;
//JSOU : 07/04/2014 : Etat Reserve pour edition
window.CURSOR_STATE_LOCK = CURSOR_STATE_LOCK;

// Id du controle Isiworkflow
window.ISIWORKFLOW = ISIWORKFLOW;
// Id du controle Isioverview
window.ISIOVERVIEW = ISIOVERVIEW;
// Id du controle IsiWorkflowImpact
window.ISIWORKFLOWIMPACT = ISIWORKFLOWIMPACT;
// Id du controle IsiExtSearch
window.ISIEXTSEARCH = ISIEXTSEARCH;

// Id du controle IsiTimeProgress.
window.ISITIMEPROGRESS = ISITIMEPROGRESS;
// id du Diagram shape
window.ISIDIAGRAMSHAPE = ISIDIAGRAMSHAPE;
// id du ComboBoxYesNoSwitch
window.ISICOMBOYESNOSWITCH = ISICOMBOYESNOSWITCH;
// id du composant scan
window.ISIASSISTANTSCAN = ISIASSISTANTSCAN;
// id du controle dynamique
window.ISIDYNAMIC = ISIDYNAMIC;
// Id du controle IsiTimeProgress.
window.ISIWEBTAB = ISIWEBTAB;

// Id du controle IsiTimeProgress.
window.ISIWEBTABITEM = ISIWEBTABITEM;

//Criteres
// valeur des operateurs
window.CRIT_ENTRE = CRIT_ENTRE;
window.CRIT_HENTRE = CRIT_HENTRE;
window.CRIT_DANS = CRIT_DANS;
window.CRIT_HDANS = CRIT_HDANS;
window.CRIT_EMPTY = CRIT_EMPTY;
window.CRIT_EQUALS = CRIT_EQUALS;
window.CRIT_DIFF = CRIT_DIFF;
window.CRIT_SUP = CRIT_SUP;
window.CRIT_SUPEQ = CRIT_SUPEQ;
window.CRIT_INF = CRIT_INF;
window.CRIT_INFEQ = CRIT_INFEQ;
// Id du sous controle connexe du controle dynamique
window.DYN_CTRLCNX = DYN_CTRLCNX;

window.CstFORM = CstFORM;
window.CstDATA = CstDATA;
window.SQLTEXTEDITOR = SQLTEXTEDITOR;
